import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Box } from '@mui/material';

interface EstadoFilterProps {
  value: 'todos' | 'activos' | 'inactivos';
  onChange: (value: 'todos' | 'activos' | 'inactivos') => void;
  loading?: boolean;
}

const EstadoFilter: React.FC<EstadoFilterProps> = ({ value, onChange, loading = false }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as 'todos' | 'activos' | 'inactivos');
  };

  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth size="small" disabled={loading}>
        <InputLabel
          id="estado-filter-label"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '14px',
          }}
        >
          Estado
        </InputLabel>
        <Select
          labelId="estado-filter-label"
          id="estado-filter"
          value={value}
          label="Estado"
          onChange={handleChange}
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '14px',
            borderColor: '#ddd',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#a0588e',
            },
          }}
        >
          <MenuItem value="todos">Todos</MenuItem>
          <MenuItem value="activos">Activos</MenuItem>
          <MenuItem value="inactivos">Inactivos</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default EstadoFilter;
